import axios from "axios";
import router from "@/router"; 
import Swal from "sweetalert2";

// const apiHost = process.env.VUE_APP_API_HOST;
// const apiPort = process.env.VUE_APP_API_PORT;
const baseUrl = process.env.VUE_APP_API_URL;

console.log(baseUrl);

const api = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  response => response, 
  async (error) => {
    if (error.response && error.response.status === 401) {
      console.warn("Token expired or unauthorized. Logging out...");

      localStorage.removeItem("token");

      Swal.fire({
        icon: "warning",
        title: "Session Expired",
        text: "Your session has expired. Please log in again.",
        confirmButtonText: "OK"
      }).then(() => {
        router.push("/login");
      });
    }
    return Promise.reject(error);
  }
);

export default api;
